import React, { Component } from 'react';
import { store } from "Store/store.index";
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Modal, Tabs, Checkbox, Button, Select, InputNumber, Radio } from 'antd';
import intl from 'react-intl-universal';
import EntryList from './EntryList.dialog';
import General from './components/Genneral';
import { fileController } from "../../viewer/Controllers/index";
import ColorPicker from '../Watermark/ColorPicker';

import "./Preferences.scss";
import { isJPDomain, isCNDomain, isAISupported } from 'Utils/utils';
import { inject, observer } from 'mobx-react';
import Identity from './Identity/Identity';
import Measurement from './measure/MeasurePreference'
import PageDisplay from './pageDisplay';
import Editing from './editing';
import FormFullScreen from './components/FullScreen.form';
import Document from './components/Document';
import Search from './search';
import Security from './security';
import TrustManager from './trustManager';
import JavaScript from './javascript/';
import AITab from './AI';
import Signature from './Signature';
import PDFSign from './PDFSign';

import {EDIT_TEXT} from '../../viewer/ui/constants/edit.constants';

const { TabPane } = Tabs;
const { Option } = Select;

@inject('appStore', 'userStore', 'accountStore', 'historyStore')
@observer
class PreferencesDialog extends Component {
  /**
   *Creates an instance of PreferencesDialog.
   * @param {Object} props
   * formPreference:{
   *    FieldsHightLight
        FieldsHightLight_argb
        FieldsHightLight_clr
        HighlightrRequiredFields
        HighlightrRequiredFields_argb
        HighlightrRequiredFields_clr
        isAutomatically
        isHideDocumentMessage
        isHighlight
        isNumericalData
        isOpenPropertiesAfterCreating
        isOverflowIndicator
        isRectangle
        isRunFormRecognition
      isRunFormRecognition,
   * }
    
   */

  static storageIdentityKey() {
    return 'IDENTITY-STORAGE-KEY';
  }
  static measuringKey() {
    return 'Measuring-KEY';
  }

  constructor(props) {
    super(props);
    this.state = {
      formPreference: store.docStore.formPreference,
      commentPreference: store.docStore.commentPreference,
      disabledColor: "#4f4b4b",
      layoutPreference: store.docStore.layoutPreference,
      searchPreference: store.docStore.searchPreference,
      showEntryList: false,
      AutoCompleteEntries: [],
      isFollowSystem: store.appStore.isFollowSystem,
      lang: store.appStore.lng.lang,
      errors: null,
      activeKey: 'formsTab',
      measureData: '',
      securityMode: 'off',
      updateSecurityModeFlag: false,
      updateTrustManageFlag: false,
      updateSafeReadingFlag: false,
      trustManage: {
        enable: true,
        subEnable: false,
        rms: true,
        signature: true
      },
      trustSite:{
        type: 'custom',
        siteRight: 'always',
        siteList: [],
      },
      enableJsAction: true,
      updateEnableJsActionFlag: false,
    }
    this.pageDisplayRef = React.createRef();
    this.documentRef = React.createRef();
    this.handleOk = this.handleOk.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeFieldsHightLight = this.onChangeFieldsHightLight.bind(this);
    this.onChangeHighlightrRequiredFields = this.onChangeHighlightrRequiredFields.bind(this);
    this.openEntryList = this.openEntryList.bind(this);
    this.closeEntryList = this.closeEntryList.bind(this);
    this.RemoveAllEntryList = this.RemoveAllEntryList.bind(this);
    this.editingRef = React.createRef();
    this.handleFormFullScreenSubmit = this.handleFormFullScreenSubmit.bind(this);
    this.handleFormFullScreenError = this.handleFormFullScreenError.bind(this);
    this.tabsChange = this.tabsChange.bind(this);
    this.signatureRef = React.createRef();
    this.PDFSignRef = React.createRef();
  }

  setSecurityModeState = val => {
    this.setState({
      securityMode: val,
      updateSecurityModeFlag: true,
    });
  }

  setTrustManageHandle = val => {
    this.setState({
      trustManage: val,
      updateSafeReadingFlag: true,
    });
  }

  setTrustSiteHandle = val => {
    this.setState({
      trustSite: val,
      updateTrustManageFlag: true,
    });
  }

  showExistInfo = () => {
    fileController.getPDFViewer().then((viewer) => {
      const msg = intl.formatMessage({ id: 'Preferences.Content.TrustManager.InternetAccess.Message.ExistUrlInfo' })
      viewer.viewerUI.alert({ message: msg, level: 'warning' });
    });
  }

  setJsActionHandle = (val) => {
    this.setState({
      enableJsAction: val,
      updateEnableJsActionFlag: true,
    });
  }

  componentDidMount() {
    this.getAutoCompleteEntries()
    this.setActiveKey();
    window.pdfui.eventEmitter.on('setSecurityModeEvt', this.setSecurityModeState);
    window.pdfui.eventEmitter.on('setTrustManageEvt', this.setTrustManageHandle);
    window.pdfui.eventEmitter.on('setTrustSiteEvt', this.setTrustSiteHandle);
    window.pdfui.eventEmitter.on('existInternetUrl', this.showExistInfo);
    window.pdfui.eventEmitter.on('js_action_event_pre', this.setJsActionHandle);
  }

  componentWillUnmount(){
    window.pdfui.eventEmitter.off('setSecurityModeEvt', this.setSecurityModeState);
    window.pdfui.eventEmitter.off('setTrustManageEvt', this.setTrustManageHandle);
    window.pdfui.eventEmitter.off('setTrustSiteEvt', this.setTrustSiteHandle);
    window.pdfui.eventEmitter.off('existInternetUrl', this.showExistInfo);
    window.pdfui.eventEmitter.off('js_action_event_pre', this.setJsActionHandle);
  }
  
  async getAutoCompleteEntries() {
    const AutoCompleteEntries = await fileController.getAllAutoCompleteEntries();
    if (!!AutoCompleteEntries) {
      this.setState({
        AutoCompleteEntries
      })
    }
  }
  setActiveKey() {
    const { visible, defaultActiveKey = 'formsTab' } = this.props;
    if (visible && defaultActiveKey && defaultActiveKey !== this.state.activeKey) {
      this.setState({
        activeKey: defaultActiveKey
      })
    }
  }
  openEntryList() {
    this.setState({
      showEntryList: true
    })
  }
  closeEntryList() {
    this.setState({
      showEntryList: false
    })
  }
  async RemoveAllEntryList() {
    await fileController.clearAllAutoCompleteEntries();
    this.getAutoCompleteEntries();
  }
  onChange() {

  }
  tabsChange(activeKey) {
    this.setState({ activeKey });
  }
  onChangeHighlightrRequiredFields(clr) {
    const obj = { ...this.state.formPreference };
    obj.HighlightrRequiredFields = clr.background;
    obj.HighlightrRequiredFields_clr = clr;
    this.setState({
      formPreference: obj
    });
  }
  onChangeFieldsHightLight(clr) {
    const obj = { ...this.state.formPreference };
    obj.FieldsHightLight = clr.background;
    obj.FieldsHightLight_clr = clr;
    this.setState({
      formPreference: obj
    });
  }

  clrToARGB = (clr) => {
    let argb;
    if (clr.rgba && clr.rgba.a) {//有选择相应颜色
      argb = clr && clr.rgba && clr.rgba.a && this.colorToAARRGGBB(clr.color, clr.rgba.a);
    } else {//未选中任何颜色
      argb = this.colorToAARRGGBB(clr.color, 1)
    }
    return argb
  }
  colorToAARRGGBB(colorHex, ap) { //将16进制颜色 & 透明度  合并转换成AARRGGBB 格式
    let apHex = this.apToHex(ap);
    let color = `0x${apHex}${colorHex.substr(1)}`
    return color;
  }
  apToHex(ap) {//透明度转16进制
    let i = ap * 100;
    let n = 255 * i / 100;
    let hexInteger = Math.round(n);
    let hex = hexInteger.toString(16);
    if (hex.length < 2) {
      hex = "0" + hex;
    }
    return hex;
  }
  handleOk() {
    const { FieldsHightLight_clr, HighlightrRequiredFields_clr } = this.state.formPreference;
    const formObj = { ...this.state.formPreference };
    const layoutObj = { ...this.state.layoutPreference };
    const searchObj = { ...this.state.searchPreference };
    formObj.FieldsHightLight_argb = this.clrToARGB(FieldsHightLight_clr);
    formObj.HighlightrRequiredFields_argb = this.clrToARGB(HighlightrRequiredFields_clr);
    this.setState({
      formPreference: formObj
    }, () => {
      let formObj = this.state.formPreference;
      this.props.onOk({
        commentPreference: this.state.commentPreference,
        formPreference: formObj,
        layoutPreference: layoutObj,
        searchPreference: searchObj
      })
    })
    this.setLanguages()
    this.setIdentity();
    this.pageDisplayLocalStorage();
    if(this.state.activeKey === 'document') {
      this.documentRef.saveSettingsToLocalStorage();
    }
    this.saveMeasure();
    this.editingRef.current && this.editingRef.current.save();
    this.state.updateSecurityModeFlag && this.setSecurityMode();
    this.state.updateSafeReadingFlag && this.setTrustManageSetting();
    this.state.updateTrustManageFlag && this.setTrustSiteSetting();
    this.state.updateEnableJsActionFlag && this.setJsAction();
    this.setSignatureConfig();
    this.setPDFSignConfig();
  }
  pageDisplayLocalStorage() {
    if (this.pageDisplayRef.current) {
      // 确定时设置localStorage
      this.pageDisplayRef.current.storageFormData();
      this.setCustomMargin();
      this.setMultipage();
      this.updateFormatPageNumbers();
      this.setPageDisplayPreferences();
    }
  }
  setCustomMargin() {
    let state = localStorage.getItem('PAGE_DISPLAY_DATA');
    if (!state) {
      return;
    }
    const pageDisplayPreferences = JSON.parse(state);
    const customMarginChecked = pageDisplayPreferences.customMarginChecked;
    let pixel = pageDisplayPreferences.margin;
    if (!customMarginChecked) {
      pixel = 10;
    }
    fileController.getPDFViewer().then((viewer) => {
      viewer.setCustomMargin(pixel);
    });
  }
  setMultipage() {
    let state = localStorage.getItem('PAGE_DISPLAY_DATA');
    if (!state) {
      return;
    }
    const pageDisplayPreferences = JSON.parse(state);
    const customFacingChecked = pageDisplayPreferences.customFacingChecked;
    let facingPages = pageDisplayPreferences.facingPages;
    if (!customFacingChecked) {
      facingPages = 2;
    }
    fileController.getPDFViewer().then((viewer) => {
      viewer.setMultipage(facingPages);
    });
  }
  updateFormatPageNumbers() {
    let state = localStorage.getItem('PAGE_DISPLAY_DATA');
    if (!state) {
      return;
    }
    fileController.getPDFViewer().then((viewer) => {
      viewer.updateFormatPageNumbers();
    });
  }
  setPageDisplayPreferences() {
    let state = localStorage.getItem('PAGE_DISPLAY_DATA');
    if (!state) {
      return;
    }
    fileController.getPDFViewer().then((viewer) => {
      viewer.setPageDisplayPreferences();
    });
  }
  handleClose() {
    this.props.onClose()
  }
  onChangeGeneral = (key, value) => {
    this.setState({
      formPreference: {
        ...this.state.formPreference,
        [key]: value
      }
    })
  }
  onChangeComment = (key, value) => {
    this.setState({
      commentPreference: {
        ...this.state.commentPreference,
        [key]: value
      }
    })
  }
  AutoComplete_Change = (key, value) => {
    this.setState({
      formPreference: {
        ...this.state.formPreference,
        [key]: value
      }
    })

  }
  LayoutGridChange = (option, value) => {
    this.setState({
      layoutPreference: {
        ...this.state.layoutPreference,
        [option]: value
      }
    })
  }

  SearchChange = (option, value) => {
    this.setState({
      searchPreference: {
        ...this.state.searchPreference,
        [option]: value
      }
    })
  }

  setLanguages = () => {
    const { lang, isFollowSystem } = this.state
    store.appStore.changeFollowSystemLng(isFollowSystem, lang)
  }

  setSignatureConfig = () => {
    if (this.signatureRef.current) {
      // 校验规则
      let verifyRule = this.signatureRef.current.getVerifySignatureRule();
      store.appStore.updateVerifySignatureRule(verifyRule);
    }
  }

  setPDFSignConfig = () => {
    if (this.PDFSignRef.current) {
      this.PDFSignRef.current.setPdfSignConfig()
    }
  }

  useLanguage = (e) => {
    const { value } = e.target
    this.setState({
      isFollowSystem: value
    })
  }
  changeLanguage = (e) => {
    const { value } = e.target
    this.setState({
      lang: value
    })
  }

  //   get computedActiveKey () {
  //       return this.props.defaultActiveKey
  //   }

  onChangeIdentity = (data) => {
    this.setState({ identity: data });
  }
  setIdentity = () => {
    const { identity } = this.state;
    if (identity === undefined) return;
    var arr = [];
    for (let key in identity) {
      const val = identity[key];
      val && arr.push({ id: key, content: val });
    }
    localStorage.setItem(PreferencesDialog.storageIdentityKey(), JSON.stringify(arr));
  }

  handleFormFullScreenSubmit(fullScreen) {
    const { formPreference } = this.state;
    this.setState({ formPreference: { ...formPreference, fullScreen } });
  }

  handleFormFullScreenError(errors) {
    this.setState({ errors })

  }

  setSecurityMode = () => {
    const val = this.state.securityMode;
    store.appStore.setSecurityMode(val);
    localStorage.setItem(Security.storeKey(), val);
    window.pdfui.eventEmitter.emit('isProtectedView', store.appStore.isProtectedView);

    const saveDom = document.querySelector('div[name="download-file-button"]');
    const saveDomZh = document.querySelector('div[name="save-as-file"]');
    const optimizerDom = document.querySelector('div[icon-class="fv__icon-toolbar-pdf-optimizer"]');
    const editToolBarDom = document.querySelector('div[name="edit-toolbar-group-list"]');
    const organizeToolBarDom = document.querySelector('div[name="organize-toolbar-group-list"]');
    const commentToolBarDom = document.querySelector('div[name="comment-toolbar-group-list"]');
    const formToolBarDom = document.querySelector('div[name="form-toolbar-group-list"]');
    const protectToolBarDom = document.querySelector('div[name="protect-toolbar-group-list"]');
    const searchToolDom = document.querySelector('div[name="redaction-search"]');
    const arr = [saveDom,saveDomZh,optimizerDom,editToolBarDom,organizeToolBarDom,commentToolBarDom,formToolBarDom].filter(item=>item);
    arr.forEach(dom=>{
      if(store.appStore.isProtectedView){
        dom.classList.add('disable-for-toolbar');
        protectToolBarDom&&protectToolBarDom.classList.add('disable-add');
        searchToolDom&&searchToolDom.classList.add('disable-remove');
      }else{
        dom.classList.remove('disable-for-toolbar');
        protectToolBarDom&&protectToolBarDom.classList.remove('disable-add');
        searchToolDom&&searchToolDom.classList.remove('disable-remove');
      }
    })
  }

  setTrustManageSetting = () => {
    const setting = JSON.stringify(this.state.trustManage);
    localStorage.setItem('TRUST_MANAGE_SET',setting);
    const that = this;
    fileController.getPDFViewer().then((viewer)=>{
      const isEnableJS = viewer.getEnableJS();
      const isEnableSafeMode = that.state.trustManage.enable;
      this.props.onSafeRead({isEnableJS, isEnableSafeMode});
    });
  } 

  setTrustSiteSetting = () => {
    const setting = JSON.stringify(this.state.trustSite);
    localStorage.setItem('TRUST_SITE_SET',setting);
  }

  setJsAction = () => {
    localStorage.setItem('enable_js_action', this.state.enableJsAction);
    window.pdfui.pdfViewer.setEnableJS(this.state.enableJsAction);
    window.pdfui.eventEmitter.emit('js_action_event', this.state.enableJsAction);
  }

  // 保存measure窗口数据
  saveMeasure = () => {
    const { measureData } = this.state;
    if (measureData) {
      const pdfui = window.pdfui;
      const KEY = PreferencesDialog.measuringKey();
      localStorage.setItem(KEY, JSON.stringify(measureData));
      // 发送事件通知
      pdfui.eventEmitter.emit(KEY);
      // 切换rule
      const unit = measureData.unit;
      pdfui.getComponentByName('pdf-viewer-container-with-ruler').then(component => {
        component.setUnit(unit);
      });
    }
  }

  getTabsClassName = activeKey => {
    let className = ''
    switch (activeKey) {
      case 'signatureTab':
        className = 'signature-active';
        break;
      case 'PDFSignTab':
        className = 'pdfSign-active';
        break;
      default:
        break;
    }
    return className
  }

  render() {
    const { visible } = this.props;
    const { showEntryList, AutoCompleteEntries, isFollowSystem, lang, errors = [], activeKey } = this.state;
    const { GridLineColcor, WidthBetweenLines, HeightBetweenLines, GridOffsestFromLeftEdge, GridOffsestFromTopEdge, Subdivisions } = this.state.layoutPreference;
    const {
      FieldsHightLight,
      HighlightrRequiredFields,
      isAutomatically,
      isRectangle,
      isHideDocumentMessage,
      isHighlight,
      isOpenPropertiesAfterCreating,
      isRunFormRecognition,
      isRememberNumerical,
      isAutoComplete,
      fullScreen,
    } = this.state.formPreference;
    const { isTextAsContent, isPopupFloatbar } = this.state.commentPreference;
    const isCN_Domain = isCNDomain();
    const isJP_Domain = isJPDomain();
    const layout_LayoutGrid = {
      labelCol: { span: 9 },
      wrapperCol: { span: 14, offset: 1 },
    };

    const isEditingDisable = store.appStore.isDisableButton(EDIT_TEXT, false);
    let tabsClassName = this.getTabsClassName(activeKey)

    const flag = store.appStore.aiUIFlag;

    return (
      <Modal
        className='preferences-dialog'
        maskClosable={false}
        title={intl.formatMessage({ id: 'Preferences.Modal.Title' })}
        visible={visible}
        cancelText={intl.formatMessage({ id: 'Preferences.Modal.Cancel' })}
        okText={intl.formatMessage({ id: 'Preferences.Modal.Ok' })}
        okButtonProps={{ disabled: errors !== null && errors[0] }}
        onOk={this.handleOk}
        onCancel={this.handleClose}
        centered={true}
      >
        <Tabs
          activeKey={activeKey}
          tabPosition='left'
          style={{ height: 450 }}
          onChange={this.tabsChange}
          className={tabsClassName}>
          {
            !isEditingDisable && <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.Editing' })} key='Editing'><Editing ref={this.editingRef}></Editing></TabPane>
          }
          {(!!(flag&1))&&isAISupported()&&<TabPane tab={intl.formatMessage({ id: 'GetStartGuid.aiAssistant' })} key='AITab'><AITab></AITab></TabPane>}
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.CommentTab.title' })} key='CommentTab'>
            <div className="title">{intl.formatMessage({ id: 'Preferences.Content.CommentTab.MakingComments' })}</div>
            <div className="board">
              <div className="row">
                <Checkbox className='checkbox-align' checked={isTextAsContent} onChange={(event) => this.onChangeComment("isTextAsContent", event.target.checked)}>
                  {intl.formatMessage({ id: 'Preferences.Content.CommentTab.TextAsContent' })}
                </Checkbox>
              </div>
            </div>
            <div className="title">{intl.formatMessage({ id: 'Preferences.Content.CommentTab.FloatBar.Title' })}</div>
            <div className="board">
              <div className="row">
                <Checkbox className='checkbox-align' checked={isPopupFloatbar} onChange={(event) => this.onChangeComment("isPopupFloatbar", event.target.checked)}>
                  {intl.formatMessage({ id: 'Preferences.Content.CommentTab.FloatBar.Content' })}
                </Checkbox>
              </div>
            </div>
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.DocumentTab.tabTitle'})} key='document'>
              <Document ref={component => this.documentRef = component } />
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.FormsTab' })} key='formsTab'>
            <div className="title">{intl.formatMessage({ id: 'Preferences.Content.General.Title' })}</div>
            <div className="board">
              <div className="row">
                <Checkbox checked={isAutomatically} onChange={(event) => this.onChangeGeneral("isAutomatically", event.target.checked)}>
                  {intl.formatMessage({ id: 'Preferences.Content.General.isAutomatically' })}
                </Checkbox>
              </div>
              <div className="row">
                <Checkbox checked={isRectangle} onChange={(event) => this.onChangeGeneral("isRectangle", event.target.checked)}>
                  {intl.formatMessage({ id: 'Preferences.Content.General.isRectangle' })}

                </Checkbox>
              </div>
              <div className="row">
                <Checkbox checked={isHideDocumentMessage} onChange={(event) => this.onChangeGeneral("isHideDocumentMessage", event.target.checked)} >
                  {intl.formatMessage({ id: 'Preferences.Content.General.isHideDocumentMessage' })}
                </Checkbox>
              </div>
              <div className="row">
                <Checkbox checked={isHighlight} onChange={(event) => this.onChangeGeneral("isHighlight", event.target.checked)} >
                  {intl.formatMessage({ id: 'Preferences.Content.General.isHighlight' })}
                </Checkbox>
              </div>
              <div className={!isHighlight ? 'opacity_05' : ''}>
                <div className="row">
                  <div className='labelName'>
                    <span>{intl.formatMessage({ id: 'Preferences.Content.General.FieldsHighlight' })}</span>
                    <ColorPicker color={FieldsHightLight} disabled={!isHighlight} onChangeComplete={this.onChangeFieldsHightLight} disableAlpha={true} />
                  </div>
                </div>
                <div className="row">
                  <div className='labelName'>
                    <span>{intl.formatMessage({ id: 'Preferences.Content.General.HighlightRequiredFields' })}</span>
                    <ColorPicker PickerStyle={{ top: '-100px' }} color={HighlightrRequiredFields} disabled={!isHighlight} onChangeComplete={this.onChangeHighlightrRequiredFields} disableAlpha={true} />
                  </div>
                </div>
              </div>
              <div className="row">
                <Checkbox checked={isOpenPropertiesAfterCreating} onChange={(event) => this.onChangeGeneral("isOpenPropertiesAfterCreating", event.target.checked)} >
                  {intl.formatMessage({ id: 'Preferences.Content.General.isOpenPropertiesAfterCreating' })}
                </Checkbox>
              </div>
              <div className="row">
                <Checkbox checked={isRunFormRecognition} onChange={(event) => this.onChangeGeneral("isRunFormRecognition", event.target.checked)} >
                  {intl.formatMessage({ id: 'Preferences.Content.General.isRunFormRecognition' })}
                </Checkbox>
              </div>
            </div>
            <div className="title">{intl.formatMessage({ id: 'Preferences.Content.AutoComplete.Title' })}</div>
            <div className="board">
              <div className="row">
                <Select getPopupContainer={triggerNode => triggerNode.parentNode} defaultValue={intl.formatMessage({ id: `Preferences.Content.AutoComplete.AutoCompleteSelect.${isAutoComplete}` })} style={{ width: 120 }} size="small" onChange={(value) => { this.AutoComplete_Change("isAutoComplete", value) }}>
                  <Option value="off">{intl.formatMessage({ id: 'Preferences.Content.AutoComplete.AutoCompleteSelect.off' })}</Option>
                  <Option value="basic">{intl.formatMessage({ id: 'Preferences.Content.AutoComplete.AutoCompleteSelect.basic' })}</Option>
                  {/* <Option value="advanced">{intl.formatMessage({ id: 'Preferences.Content.AutoComplete.AutoCompleteSelect.advanced' })}</Option> */}
                </Select>
                <Checkbox disabled={isAutoComplete == 'off'} checked={isAutoComplete == 'off' ? false : isRememberNumerical} onChange={(event) => this.AutoComplete_Change("isRememberNumerical", event.target.checked)} >
                  {intl.formatMessage({ id: 'Preferences.Content.AutoComplete.RememberNumerical' })}
                </Checkbox>
              </div>
              <div className="row">
                <Button size='small' style={{ padding: '0 15px' }} onClick={this.openEntryList}>{intl.formatMessage({ id: 'Preferences.Content.AutoComplete.EditEntryButton' })} </Button>
              </div>
              <div className="row">
                <div className="CompleteMsg">
                  {isAutoComplete == 'off' && intl.formatMessage({ id: 'Preferences.Content.AutoComplete.TextAreaTxt' })}
                  {isAutoComplete == 'basic' && intl.formatMessage({ id: 'Preferences.Content.AutoComplete.TextAreaTxt_basic' })}
                  {isAutoComplete == 'advanced' && intl.formatMessage({ id: 'Preferences.Content.AutoComplete.TextAreaTxt_advanced' })}
                </div>
              </div>
            </div>
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.FullScreen.Title' })} key="fullScreen">
            <FormFullScreen value={fullScreen} onSubmit={this.handleFormFullScreenSubmit} onError={this.handleFormFullScreenError} />
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.General.Title' })} key='general'>
            <General></General>
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.IdentityTab' })} key='identityTab'>
            <Identity onChange={this.onChangeIdentity}></Identity>
          </TabPane>
          {!isJP_Domain && !isCN_Domain && <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.LanguagesTab' })} key='languagesTab'>
            <div className="title">{intl.formatMessage({ id: 'Preferences.Content.Languages.Title' })}</div>
            <div className="board">
              <div className="row">
                <Radio.Group onChange={this.useLanguage} value={isFollowSystem}>
                  <Radio className="language-radio" value={true}>
                    {intl.formatMessage({ id: 'Preferences.Content.Languages.UseSystem' })}
                  </Radio>
                  <Radio className="language-radio" value={false}>
                    {intl.formatMessage({ id: 'Preferences.Content.Languages.UserCustom' })}
                  </Radio>
                </Radio.Group>
              </div>
              {!isFollowSystem && <div className="row custom-box">
                <Radio.Group onChange={this.changeLanguage} value={lang}>
                  {<Radio className="language-radio" value={'en'}>English</Radio>}
                  {<Radio className="language-radio" value={'es'}>Español</Radio>}
                  {<Radio className="language-radio" value={'de'}>Deutsch</Radio>}
                  {<Radio className="language-radio" value={'fr'}>Français</Radio>}
                  {<Radio className="language-radio" value={'it'}>Italiano</Radio>}
                  {<Radio className="language-radio" value={'nl'}>Nederlands</Radio>}
                  {<Radio className="language-radio" value={'ja'}>日本語</Radio>}
                  {<Radio className="language-radio" value={'zh'}>简体中文</Radio>}
                  {<Radio className="language-radio" value={'ko'}>한국어</Radio>}
                </Radio.Group>
              </div>}
            </div>

          </TabPane>}
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.LayoutGridTab' })} key='layoutGridTab' >
            <div className="title">{intl.formatMessage({ id: 'Preferences.Content.LayoutGrid.Title' })}</div>
            <div className="LayoutGrid">
              <Form
                {...layout_LayoutGrid}
                name="Layout Grid"
                size='small'
              >
                <Form.Item
                  label={intl.formatMessage({ id: 'Preferences.Content.LayoutGrid.WidthBetweenLines' })}
                  name="WidthBetweenLines"
                  rules={[{ required: true, message: 'Please input number!' }]}
                >
                  <div>
                    <InputNumber defaultValue={WidthBetweenLines} style={{ width: '240px' }} min={0} max={100} step={0.250} precision={3} onChange={(value) => { this.LayoutGridChange('WidthBetweenLines', value) }} />

                    <span> {intl.formatMessage({ id: 'Preferences.Content.LayoutGrid.inch' })} </span>
                  </div>
                </Form.Item>

                <Form.Item
                  label={intl.formatMessage({ id: 'Preferences.Content.LayoutGrid.HeightBetweenLines' })}
                  name="HeightBetweenLines"
                  rules={[{ required: true, message: 'Please input number!' }]}
                >
                  <div>
                    <InputNumber defaultValue={HeightBetweenLines} style={{ width: '240px' }} min={0} max={100} step={0.250} precision={3} onChange={(value) => { this.LayoutGridChange('HeightBetweenLines', value) }} />
                    <span>  {intl.formatMessage({ id: 'Preferences.Content.LayoutGrid.inch' })}  </span>
                  </div>
                </Form.Item>
                <Form.Item
                  label={intl.formatMessage({ id: 'Preferences.Content.LayoutGrid.GridOffsestFromLeftEdge' })}
                  name="GridOffsestFromLeftEdge"
                  rules={[{ required: true, message: 'Please input number!' }]}
                >
                  <div>
                    <InputNumber defaultValue={GridOffsestFromLeftEdge} style={{ width: '240px' }} min={0} max={100} step={0.250} precision={3} onChange={(value) => { this.LayoutGridChange('GridOffsestFromLeftEdge', value) }} />
                    <span>  {intl.formatMessage({ id: 'Preferences.Content.LayoutGrid.inch' })}  </span>
                  </div>
                </Form.Item>
                <Form.Item
                  label={intl.formatMessage({ id: 'Preferences.Content.LayoutGrid.GridOffsestFromTopEdge' })}
                  name="GridOffsestFromTopEdge"
                  rules={[{ required: true, message: 'Please input number!' }]}
                >
                  <div>
                    <InputNumber defaultValue={GridOffsestFromTopEdge} style={{ width: '240px' }} min={0} max={100} step={0.250} precision={3} onChange={(value) => { this.LayoutGridChange('GridOffsestFromTopEdge', value) }} />
                    <span> {intl.formatMessage({ id: 'Preferences.Content.LayoutGrid.inch' })} </span>
                  </div>
                </Form.Item>
                <Form.Item
                  label={intl.formatMessage({ id: 'Preferences.Content.LayoutGrid.Subdivisions' })}
                  name="Subdivisions"
                  rules={[{ required: true, message: 'Please input number!' }]}
                >
                  <div>
                    <InputNumber defaultValue={Subdivisions} style={{ width: '240px' }} min={0} max={100} step={1} precision={0} onChange={(value) => { this.LayoutGridChange('Subdivisions', value) }} />
                    <span> {intl.formatMessage({ id: 'Preferences.Content.LayoutGrid.inch' })} </span>
                  </div>
                </Form.Item>
                <Form.Item
                  label={intl.formatMessage({ id: 'Preferences.Content.LayoutGrid.GridLineColcor' })}
                  name="GridLineColcor"
                  rules={[{ required: true, message: 'Please input number!' }]}
                >
                  <ColorPicker PickerStyle={{ top: '-200px' }} className='GridLineColcor_ColorPicker' color={GridLineColcor} onChangeComplete={(clr) => { this.LayoutGridChange('GridLineColcor', clr.color) }} />
                </Form.Item>
              </Form>
            </div>
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.MeasureTab' })} className="measurementPreference" key="measurementTab">
            <Measurement onChange={(measureData) => this.setState({ measureData })}></Measurement>
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.PDFSignTab' })} key='PDFSignTab'>
            <PDFSign ref={this.PDFSignRef}></PDFSign>
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.PageDisplayTab' })} key='pageDisplayTab'>
            <PageDisplay ref={this.pageDisplayRef}></PageDisplay>
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.SearchTab' })} key='searchTab'>
            <Search searchChange={this.SearchChange} searchPreference={this.state.searchPreference} />
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.SecurityTab' })} key='securityTab'>
            <Security></Security>
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.SignatureTab' })} key='signatureTab'>
            <Signature ref={this.signatureRef} />
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.TrustManagerTab' })} key='trustManagerTab'>
            <TrustManager></TrustManager>
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'Preferences.Content.JavaScriptTab' })} key='JavascriptTab'>
            <JavaScript></JavaScript>
          </TabPane>
        </Tabs>
        <EntryList visible={showEntryList} close={this.closeEntryList} AutoCompleteEntries={AutoCompleteEntries} handleRemoveAll={this.RemoveAllEntryList}></EntryList>
      </Modal>
    );
  }
}
export default Form.create({ name: 'PreferencesDialogForm' })(PreferencesDialog)
